import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "app-assignment"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "目标名称", -1);

const _hoisted_5 = {
  class: "wrapper"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "目标类型", -1);

const _hoisted_7 = {
  class: "wrapper"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "状态", -1);

const _hoisted_9 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("新增目标");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("作废");

const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 详情/进度 ");

import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { getVexTableProps } from '@/config';
import { ElMessageBox, ElMessage } from 'element-plus';
import axios from '@/request/createAxiosInstalce';
import Tool from '@/utils/tool';
import { taskCancel, targetList } from '@/request';
export default {
  name: 'index',

  setup(__props) {
    const router = useRouter();
    const search = reactive({
      dateRange: [],
      status: '',
      name: ''
    });
    const targetType = ref('');
    const statusList = [{
      name: '全部',
      value: ''
    }, {
      name: '未开始',
      value: '0',
      color: '#E6A23C'
    }, {
      name: '进行中',
      value: '1',
      color: '#67C23A'
    }, {
      name: '已结束',
      value: '2',
      color: '#73767a'
    }, {
      name: '已作废',
      value: '3',
      color: '#b1b3b8'
    }];
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '目标类型',
        field: 'targetType',
        width: 100,
        slots: {
          default: 'targetType'
        }
      }, {
        title: '目标名称',
        field: 'targetName'
      }, {
        title: '目标商品',
        field: 'prods'
      }, {
        title: '目标值',
        field: 'targetSales',
        width: 140,
        slots: {
          default: 'targetSales'
        }
      }, {
        title: '整体进度',
        field: 'progress'
      }, {
        title: '考核指标',
        field: 'assessKpi'
      }, {
        title: '考核团队/人数',
        field: 'teamUser'
      }, {
        title: '考核周期',
        field: 'assessPeriod'
      }, {
        title: '目标奖励',
        field: 'rewardDesc',
        slots: {
          default: 'rewardDesc'
        }
      }, {
        title: '最近修改时间',
        field: 'updateAt',
        width: 160
      }, {
        title: '状态',
        field: 'status',
        width: 70,
        slots: {
          default: 'status'
        }
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        },
        width: 200
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            let start = search.dateRange[0];
            let end = search.dateRange[1];
            let params = {
              page: page.currentPage,
              pageSize: page.pageSize,
              targetType: targetType.value,
              startTime: start ? `${start} 00:00:00` : undefined,
              endTime: end ? `${end} 23:59:59` : undefined,
              status: search.status,
              targetName: search.name
            };
            targetList(params).then(data => {
              res({
                total: data.total,
                result: data.data
              });
            });
          })
        }
      }
    });

    function reset() {
      search.dateRange = [];
      search.status = '';
      search.name = '';
      targetType.value = '';
      table.value.commitProxy('reload');
    }

    function destroyHandle(targetId) {
      ElMessageBox.confirm('作废后，将通知团队成员，目标将无法继续执行，确认是否作废?', '提示', {
        type: 'warning'
      }).then(() => {
        axios.post(`/admin/taskManager/target/cancel?targetId=${targetId}`).then(res => {
          let {
            success,
            msg
          } = res.data;

          if (success) {
            ElMessage.success('操作成功');
            table.value.commitProxy('reload');
          } else {
            ElMessage.error(msg);
          }
        });
      });
    }

    function formatTime(time) {
      return time && time.split(' ')[0];
    }

    function formatStatus(status) {
      return statusList.find(item => item.name == status) || {};
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_input, {
        modelValue: search.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.name = $event),
        placeholder: "请输入任务名称"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_select, {
        modelValue: targetType.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => targetType.value = $event),
        placeholder: "请选择任务类型"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "销量",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "销售额",
          value: "2"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_select, {
        modelValue: search.status,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => search.status = $event)
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusList, item => {
          return _createVNode(_component_el_option, {
            value: item.value,
            label: item.name,
            key: item.value
          }, null, 8, ["value", "label"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_9]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      })]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
          name: 'goalUpdate'
        }))
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        targetType: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.targetType == 1 ? '销量' : '销售额'), 1)]),
        targetSales: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.targetType == 1 ? '销量：' : '销售额：'), 1), _createElementVNode("span", null, _toDisplayString(row.targetType == 2 ? '￥' : '') + " " + _toDisplayString(_unref(Tool).formatNumber(row.targetSales)), 1)]),
        rewardDesc: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.rewardDesc || '无'), 1)]),
        status: _withCtx(({
          row
        }) => [_createElementVNode("span", {
          style: _normalizeStyle(`color:${formatStatus(row.status)['color']}`)
        }, _toDisplayString(formatStatus(row.status)['name']), 5)]),
        operation: _withCtx(({
          row
        }) => [row.status == '待开始' || row.status == '进行中' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "danger",
          link: "",
          onClick: $event => destroyHandle(row.targetId)
        }, {
          default: _withCtx(() => [_hoisted_12]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          type: "primary",
          link: "",
          onClick: $event => _unref(router).push({
            name: 'goalDetail',
            query: {
              targetId: row.targetId
            }
          })
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16)]);
    };
  }

};